import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { verifySignup } from '../API';

const SignupVerify = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      setError('Lien de vérification invalide.');
      setLoading(false);
      return;
    }

    verifySignup(token)
      .then(() => {
        navigate('/');
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [navigate, searchParams]);

  return (
    <div className="container pt-4">
      <div className="container-fluid col-sm-8 col-lg-6">
        <div className="jumbotron mt-2">
          <h1 className="display-4">Vérification du courriel</h1>

          {loading && !error && (
            <p className="lead">Confirmation de votre compte en cours...</p>
          )}

          {error && (
            <>
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
              <p className="mb-0">
                <Link to="/login">Retour à la connexion</Link>
                {' pour renvoyer le courriel de vérification.'}
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SignupVerify;
